

// docs https://github.com/azouaoui-med/react-pro-sidebar
import { useState } from "react";
import { Menu, Sidebar, MenuItem } from "react-pro-sidebar";
import { useProSidebar } from "react-pro-sidebar";
import logo from '../assets/img/codeflare-app.webp';
import css from '../assets/img/css.png';
import user from '../assets/img/user.png';
import { useSidebarContext } from "./SidebarCourseContext";
import Greet  from '../components/GreetUser';
import { Link } from "react-router-dom";
import { tokens } from "../theme";
import { useTheme, Box, Typography, IconButton } from "@mui/material";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import LibraryBooksOutlinedIcon from "@mui/icons-material/LibraryBooksOutlined";
import MarkUnreadChatAltOutlinedIcon from "@mui/icons-material/MarkUnreadChatAltOutlined";
import LocalLibraryOutlinedIcon from "@mui/icons-material/LocalLibraryOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import CardMembershipOutlinedIcon from "@mui/icons-material/CardMembershipOutlined";
import LoyaltyOutlinedIcon from "@mui/icons-material/LoyaltyOutlined";
import AccountBoxOutlinedIcon from "@mui/icons-material/AccountBoxOutlined";
import DirectionsRunOutlinedIcon from "@mui/icons-material/DirectionsRunOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import PieChartOutlineOutlinedIcon from "@mui/icons-material/PieChartOutlineOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import SwitchRightOutlinedIcon from "@mui/icons-material/SwitchRightOutlined";
import SwitchLeftOutlinedIcon from "@mui/icons-material/SwitchLeftOutlined";
const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <MenuItem
      active={selected === title}
      style={{ color: colors.white[100] }}
      onClick={() => setSelected(title)}
      icon={icon}
      routerLink={<Link to={to} />}
    >

      <Typography>{title}</Typography>
    </MenuItem>
  );
};

const CSSCourseNav = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [selected, setSelected] = useState("");
  const { sidebarRTL, setSidebarRTL, sidebarImage } = useSidebarContext();
  const { collapseSidebar, toggleSidebar, collapsed, broken } = useProSidebar();
  return (
    <Box
      sx={{
        position: "sticky",
        display: "flex",
        height: "100vh",
        top: 0,
        bottom: 0,
        zIndex: 10000,
        "& .sidebar": {
          border: "none",
        },
        "& .menu-icon": {
          backgroundColor: "transparent !important",
        },
        "& .menu-item": {
          padding: "5px 35px 5px 20px !important",
          backgroundColor: "transparent !important",
        },
        "& .menu-anchor": {
          color: "inherit !important",
          backgroundColor: "transparent !important",
        },
        "& .menu-item:hover": {
          color: `${colors.blueAccent[100]} !important`,
          backgroundColor: `${colors.blueAccent[100]} !important`,
        },
        "& .menu-item.active": {
          color: `${colors.blueAccent[100]} !important`,
          backgroundColor: `${colors.blueAccent[100]} !important`,
        },
      }}
    >
      <Sidebar
        breakPoint="md"
        rtl={sidebarRTL}
        backgroundColor={colors.primary[200]}
        image={sidebarImage}
      >
        <Menu iconshape="square"
        menuItemStyles={{
        button: ({ level, active, disabled }) => {
          // only apply styles on first level elements of the tree
          return {
           color: disabled ? '#f5d9ff' : '#FFF',
           backgroundColor: active ? '#eecef9' : undefined,
           '&:hover': {
              backgroundColor: 'hsl(217, 28%, 15%)',
            },
         };
        },
      }}

        >
          <MenuItem
            icon={
              collapsed ? (
                <MenuOutlinedIcon onClick={() => collapseSidebar()} />
              ) : sidebarRTL ? (
                <SwitchLeftOutlinedIcon
                  onClick={() => setSidebarRTL(!sidebarRTL)}
                />
              ) : (
                <SwitchRightOutlinedIcon
                  onClick={() => setSidebarRTL(!sidebarRTL)}
                />
              )
            }
            style={{
              margin: "10px 0 20px 0",
              color: colors.blueAccent[100],
            }}
          >
            {!collapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px"
              >
              <img
                className="avater-image"
                alt="Codefussion"
                width="30%"
                height="auto"
                src={logo}
                style={{ cursor: "pointer", alignSelf: 'center' }}
              />
                <IconButton
                  onClick={
                    broken ? () => toggleSidebar() : () => collapseSidebar()
                  }
                >
                  <CloseOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>
          {!collapsed && (
            <Box mb="25px">
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                  "& .avater-image": {
                    backgroundColor: colors.primary[500],
                  },
                }}
              >
                <img
                  className="avater-image"
                  alt="profile user"
                  width="72px"
                  height="72px"
                  src={css}
                  style={{ cursor: "pointer" }}
                />
              </Box>
              <Box textAlign="center">
                <Typography
                  variant="h3"
                  color={colors.white[100]}
                  fontWeight="bold"
                  sx={{ m: "10px 0 0 0" }}
                  style={{ textAlign: 'center' }}
                >
                  {/*<Greet /> */}
                  <h3 className="text-light">CSS 3</h3>
                </Typography>
              </Box>
            </Box>
          )}
          <Box paddingLeft={collapsed ? undefined : "1%"}>

          <MenuItem data-toggle="tooltip" data-placement="top" title="Go to Dashbord" className={window.location.href.toString().includes("dashboard") ? 'active' : ''} icon={<HomeOutlinedIcon />} component={<Link to="/dashboard" />}>Go to Dashbord</MenuItem>
          <MenuItem data-toggle="tooltip" data-placement="top" title="Course Outline" className={window.location.href.toString().includes("css-course-outline") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/css-course-outline" />}>Course outline</MenuItem>
          <MenuItem data-toggle="tooltip" data-placement="top" title="What is CSS" className={window.location.href.toString().includes("css-what-is-css") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/css-what-is-css" />}>1. What is CSS?</MenuItem>
          <MenuItem data-toggle="tooltip" data-placement="top" title="Importance of CSS" className={window.location.href.toString().includes("css-importance-of-css") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/css-importance-of-css" />}>2. Importance of CSS</MenuItem>
          <MenuItem data-toggle="tooltip" data-placement="top" title="Latest CCS3 Features" className={window.location.href.toString().includes("css-latest-css3-features") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/css-latest-css3-features" />}>3. Latest CSS3 Features</MenuItem>
          <MenuItem data-toggle="tooltip" data-placement="top" title="Syntax and Selectors" className={window.location.href.toString().includes("css-syntax-and-selectors") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/css-syntax-and-selectors" />}>4. Syntax and Selectors</MenuItem>
          <MenuItem data-toggle="tooltip" data-placement="top" title="How to use CSS" className={window.location.href.toString().includes("css-how-to-use-css") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/css-how-to-use-css" />}>5. How to use CSS</MenuItem>
          <MenuItem data-toggle="tooltip" data-placement="top" title="The Display Properties" className={window.location.href.toString().includes("css-the-display-properties") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/css-the-display-properties" />}>6. The Display Properties</MenuItem>
          <MenuItem data-toggle="tooltip" data-placement="top" title="Width and Max-width" className={window.location.href.toString().includes("css-width-and-maxwidth") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/css-width-and-maxwidth" />}>7.Width and Max-width</MenuItem>
          <MenuItem data-toggle="tooltip" data-placement="top" title="Text Color" className={window.location.href.toString().includes("css-text-color") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/css-text-color" />}>8. Text Color</MenuItem>
          <MenuItem data-toggle="tooltip" data-placement="top" title="Letter Spacing" className={window.location.href.toString().includes("css-letter-spacing") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/css-letter-spacing" />}>9. Letter Spacing</MenuItem>
          <MenuItem data-toggle="tooltip" data-placement="top" title="CSS Padding" className={window.location.href.toString().includes("css-css-padding") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/css-css-padding" />}>10. CSS Padding</MenuItem>
          <MenuItem data-toggle="tooltip" data-placement="top" title="Padding and Element width" className={window.location.href.toString().includes("css-padding-and-element-width") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/css-padding-and-element-width" />}>11. Padding and Element Width</MenuItem>
          <MenuItem data-toggle="tooltip" data-placement="top" title="CSS Border and Border style" className={window.location.href.toString().includes("css-css-border-and-border-style") ? 'active' : 'menu-link'} icon={<SchoolOutlinedIcon />} component={<Link to="/css-css-border-and-border-style" />}>12. CSS Border/Border Style</MenuItem>



          </Box>
        </Menu>
      </Sidebar>
    </Box>
  );
};

export default CSSCourseNav;
